import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=1507d3be&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=1507d3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507d3be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1507d3be')) {
      api.createRecord('1507d3be', component.options)
    } else {
      api.reload('1507d3be', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=1507d3be&scoped=true&", function () {
      api.rerender('1507d3be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Customers/Edit.vue"
export default component.exports